import React from 'react';
import { PARTS, EMPTY_ROW } from './feeTiers';

// Inline fee-tiers editor used by the Order By form. `rows` are strings (see feeTiers.js);
// no rows = no fee. Base = price × qty + Japan delivery fee; the first row whose
// "Up to ¥" covers the base applies and its parts add up.

const input = 'px-2 block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm';

export default function FeeTiersEditor({ rows, onChange }) {
  const set = (i, field, value) => onChange(rows.map((r, j) => (j === i ? { ...r, [field]: value } : r)));
  return (
    <div className="space-y-2">
      <p className="text-xs text-gray-500">
        Base = price × qty + Japan delivery fee. The first row whose "Up to ¥" covers the base applies; its parts add up.
        Leave the last row's "Up to ¥" empty for "and above". No row = no fee.
      </p>
      {rows.length > 0 && (
        <div className="grid gap-1 text-xs text-gray-600" style={{ gridTemplateColumns: '1.2fr 1fr 1fr 1fr 1fr 28px' }}>
          <span>Up to ¥</span>
          {PARTS.map((p) => <span key={p.field} title={p.help}>{p.label}</span>)}
          <span />
        </div>
      )}
      {rows.map((r, i) => (
        <div key={i} className="grid gap-1 items-center" style={{ gridTemplateColumns: '1.2fr 1fr 1fr 1fr 1fr 28px' }}>
          <input
            id={`tier-${i}-upto`}
            type="number"
            min="1"
            step="1"
            placeholder={i === rows.length - 1 ? 'and above' : ''}
            value={r.upToJpy}
            onChange={(e) => set(i, 'upToJpy', e.target.value)}
            className={input}
          />
          {PARTS.map((p) => (
            <input
              key={p.field}
              id={`tier-${i}-${p.field}`}
              type="number"
              min="0"
              step="any"
              title={p.help}
              value={r[p.field]}
              onChange={(e) => set(i, p.field, e.target.value)}
              className={input}
            />
          ))}
          <button type="button" aria-label="Remove tier" onClick={() => onChange(rows.filter((_, j) => j !== i))} className="text-red-600 hover:text-red-800 text-lg leading-none">×</button>
        </div>
      ))}
      <div className="flex items-center gap-3">
        <button type="button" onClick={() => onChange([...rows, { ...EMPTY_ROW }])} className="text-sm text-indigo-600 hover:text-indigo-800">+ Add tier</button>
        {rows.length === 0 && <span className="text-sm text-gray-400">No fee</span>}
      </div>
      <p className="text-xs text-gray-400">
        Jing: one row, 7%. FujiKing: one row, 5.5% + fixed ฿90. Mako: one row, rate 0.225.
        ไผ่: up to 19,999 → 5%; up to 50,000 → ¥1,000; …; last row (empty) → ¥10,000.
      </p>
    </div>
  );
}
